export const subkpis1 = [
  {
    colorcode: '4',
    count: '00',
    link: '#',
    title: 'Submitted',
  },
  {
    colorcode: '5',
    count: '00',
    link: '#',
    title: 'Reopened',
  },
]

export const responsepending = [
  {
    colorcode: '4',
    count: '00',
    link: '#',
    title: 'Reopened',
  },
  {
    colorcode: '5',
    count: '00',
    link: '#',
    title: 'Reopened',
  },
]
